import { useMutation, useQueryClient } from "react-query";
import { createApiWithPath } from "../../client";
import { queryKeys } from "../../query";
import { TallyQuestionMappingResponse } from "../../types/tally";

interface UpdateMappingTagsResponse {
  data: { mapping: TallyQuestionMappingResponse };
  meta: { code: number };
}

const updateMappingTags = async (
  mappingId: string,
  tagIds: string[],
): Promise<UpdateMappingTagsResponse> => {
  const { data } = await createApiWithPath(
    "tally",
  ).patch<UpdateMappingTagsResponse>(`/mappings/${mappingId}/tags`, {
    tag_ids: tagIds,
  });

  return data;
};

export const useUpdateMappingTags = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({
      mappingId,
      tagIds,
      formId,
    }: {
      mappingId: string;
      tagIds: string[];
      formId: string;
    }) => updateMappingTags(mappingId, tagIds),
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries(queryKeys.tallyForm(variables.formId));
      },
    },
  );
};
